import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './page-containers/home/home.component';
import { RequestDemoComponent } from './page-containers/request-demo/request-demo.component';
import { AboutComponent } from './page-containers/about/about.component';
import { PharmacyInfoComponent } from './page-containers/pharmacy-info/pharmacy-info.component';
import { ManufacturerInfoComponent } from './page-containers/manufacturer-info/manufacturer-info.component';
import { RegisterComponent } from './page-containers/register/register.component';
import { ContactComponent } from './page-containers/contact/contact.component';
import { ConectionAs2Component } from './conection-as2/conection-as2.component';

export const staticRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'pharmacy-info', component: PharmacyInfoComponent },
  { path: 'manufacturer-info', component: ManufacturerInfoComponent },
  { path: 'request-demo', component: RequestDemoComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'as2', component: ConectionAs2Component },
];
@NgModule({
  imports: [RouterModule.forChild(staticRoutes)],
  exports: [RouterModule],
})
export class StaticRoutesModule {}
